//Reference: EN065

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class Language extends Mappeable {

    idLanguagePk: number;
    txtName: string;
    mrkActive: boolean;
    mrkPossibleTranslation: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtName: this.txtName,
            mrkActive: this.mrkActive,
            mrkPossibleTranslation: this.mrkPossibleTranslation
        }
    }


}